import type { Session } from "./types";

export function safeReturnPath(value: unknown) {
  return typeof value === "string" &&
    value.startsWith("/") &&
    !value.startsWith("//") &&
    !value.includes("\\")
    ? value
    : null;
}

export function isExternalClientPath(path: string) {
  return (
    path === "/seo" ||
    path === "/client-projects" ||
    path.startsWith("/client-projects/") ||
    /^\/projects\/[^/]+\/seo$/u.test(path) ||
    path === "/help" ||
    path === "/notifications" ||
    path === "/settings/profile" ||
    path === "/settings/security"
  );
}

export function signedInDestination(session: Session, requested?: unknown) {
  const external = session.roles.includes("external_client");
  const fallback = external ? "/client-projects" : "/dashboard";
  const path = safeReturnPath(requested);
  if (!path) return fallback;
  if (!external) return path;
  return isExternalClientPath(path.split(/[?#]/u)[0]!) ? path : fallback;
}
